import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { reducer } from './reducer'
import { EntityAttributesService } from './service'
import { AttributeEffects } from './effects'

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AttributeEffects]), StoreModule.forFeature('attrs', reducer)],
  providers: [EntityAttributesService],
  declarations: [],
})
export class EntityAttributeStoreModule {}
